import { create } from 'zustand';
import { ApiUtils, PrintUtils } from '@shared/utils';
import { CardsApi } from '@shared/api';

interface UsePrintInvoicesStore {
  loading: boolean;
  data: boolean | null;
  error: string | null;
  printInvoice: (cardId: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const usePrintInvoicesStore = create<UsePrintInvoicesStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  printInvoice: async (cardId, signal) => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await CardsApi.printInvoice(cardId, signal);
      PrintUtils.printPDF(result.data);
      set({ loading: false, data: true });
    } catch (error) {
      set({ loading: false, data: false, error: ApiUtils.getApiError(error) });
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
